<template>
    <div>
        <navigation-bar Back Bell/>
        <div class="main pb-4">

            <!--todo 沒有留言時出現這區塊-->
            <div class="no-data" v-if="processList.length === 0">
                <img src="@/assets/images/QA-alt.svg"/>
                <p class="mt-4" v-if="storeId === 0">
                    有什麼想法
                    <br/>
                    都可以直接告訴我們
                </p>
                <p class="mt-4" v-else>
                    對本店有什麼想法
                    <br/>
                    都可以直接告訴我們
                </p>
            </div>

            <div class="text-center pb-3 sticky-oin" >
                <el-button round class="w-50" type="primary" v-show="storeId!==0" @click="onClickLeaveMessage">
                    我要留言
                </el-button>
            </div>

            <!--todo 留言列表-->
            <list-container>
                <category-content
                        v-for="(item, key) in processList"
                        :key="key"
                        class="custom-content">
                    <div class="listItem" @click="$router.push({name: 'Chatroom', query:{messageListId: item.id}})">

                        <!--todo 有新回應且會員未讀取時就出現-->
                        <div class="d-flex small mb-2">
                            <div class="flex-grow-1">{{ item.brandName }} {{ item.storeName }}</div>
                            <div>{{ item.createdAt }}</div>
                        </div>

                        <div class="list-title">
                            <div class="title">{{ item.title }}</div>
                            <!--todo 有新回應且會員未讀取時就出現-->
                            <div class="new-reply" v-show="!(item.isRead)">新回應</div>
                        </div>
                        <div class="list-content my-3">
                            {{ item.content }}
                        </div>
                        <div class="list-footer">
                            <!-- type=0:討論串最新一則留言是 user的，type=1:最新一則留言店家的-->
                            <div v-if="item.type === 0" class="status is-noreply">
                                <i class="el-icon-warning-outline"/>
                                <span> 待回覆 </span>
                            </div>
                            <div v-if="item.type === 1" class="status is-reply">
                                <i class="el-icon-check"/>
                                <span> 已回覆 </span>
                            </div>
                            <div v-if="item.type === 2" class="status is-closed">
                                <i class="el-icon-document-delete"/>
                                <span> 已關閉留言 </span>
                            </div>
                            <el-button type="warning" size="mini" round>查看／回覆</el-button>
                        </div>
                    </div>
                </category-content>
            </list-container>
        </div>
    </div>
</template>
<script>
    import CategoryContent from "@/components/category/Content.vue";
    import ListContainer from "@/components/lists/Container.vue";

    const ReplyStatus = ['reply', 'noreply', 'closed'];


    export default {
        name: "Feedback",
        components: {
            CategoryContent,
            ListContainer,
        },
        data() {
            return {
                processList: [
                    // {
                    //     category: "分店名稱",
                    //     title: "我是標題",
                    //     timestamp: "2020-06-13 10:00",
                    //     content:
                    //         "內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容",
                    //     status: "reply",
                    // },
                    // ...
                ],
                storeId: Number(this.$route.query.storeId? this.$route.query.storeId: 0 ),        //店家 ID
            };
        },
        created() {

        },
        mounted() {
            this.callFeedbackLogApi(this.storeId, 0);
        },
        methods: {

            /** 點擊 我要留言 */
            onClickLeaveMessage : function() {
                this.$router.push({name: 'MessageForm', query:{storeId: this.storeId}});
            },

            /** 歷史記錄列表 */
            callFeedbackLogApi : function(storeId, offset) {
                let self = this
                return new Promise(function(resolve, reject) {
                        self.$http.fetchWithAuth`GetFeedbackLog${{
                        id: storeId,    //篩選用,帶入id會查出分店列表,沒帶(0) 則列出全部
                        offset: offset,    //
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.processList = json.data;
                            // json.data.forEach(function (item) {
                            //     self.processList.push({
                            //         id: item.id,
                            //         storeName: item.storeName,
                            //         title: item.title,
                            //         createdAt: item.createdAt,
                            //         content: item.content,        //.replace(/\\u/gi,'%u'),
                            //         status: (item.type === 0)?'noreply':'reply',
                            //         isRead: item.isRead,
                            //     });
                            // });

                            //console.log(`confirmBookingUrl : ${self.confirmBookingUrl}`);
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },
        },
    };
</script>

<style lang="less" scoped src="../../../less/feedback.less"/>